import { t } from '@framework/i18n';
import { yup } from '@framework/validation';

/**
 * Schema della risposta a una comunicazione: il richiedente può inserire
 * esclusivamente un messaggio di testo. Tipo comunicazione e modalità di
 * trasmissione sono derivati dal backend dalla comunicazione originale.
 */
export const ReplyCommunicationRequestSchema = yup.object({
  messaggio: yup
    .string()
    .label(t('communication-request-schema.message', 'Messaggio'))
    .default('')
    .required(),
});

export type ReplyCommunicationRequest = yup.InferType<
  typeof ReplyCommunicationRequestSchema
>;
